<template>
  <v-btn class="primary pa-4" x-large :to="{name: 'Equipment'}">Equipment</v-btn>
</template>

<script>
  export default {
    name: "equipment-button"
  }
</script>

<style scoped>

</style>
